import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class CdekCitiesByLocationRequestQuery
*  Query params for operation "CdekCitiesByLocation"
*/
export class CdekCitiesByLocationRequestQuery extends ActiveModel {

  /**
  * Latitude
  * Широта<br>  */
  @ActiveField()
  Latitude?: number


  /**
  * Longitude
  * Долгота<br>  */
  @ActiveField()
  Longitude?: number
}
